<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1034.74 738.51"
  >
    <defs>
      <style>
        .cls-1 {
          fill: #ce045b;
        }
        .cls-2 {
          fill: #fff;
        }
        .cls-3 {
          fill: #ffd400;
        }
        .cls-4 {
          fill: #9acd32;
        }
        .cls-5 {
          fill: #333;
        }
        .cls-6,
        .cls-7,
        .cls-8 {
          fill: none;
          stroke-width: 24px;
        }
        .cls-6 {
          stroke: #ffd400;
        }
        .cls-7 {
          stroke: #ce045b;
        }
        .cls-7,
        .cls-8 {
          stroke-miterlimit: 10;
        }
        .cls-8 {
          stroke: #9acd32;
        }
      </style>
      <symbol
        id="point-yamanote"
        data-name="point-yamanote"
        viewBox="0 0 80 80"
      >
        <circle class="cls-4" cx="40" cy="40" r="40" />
        <circle class="cls-2" cx="40" cy="40" r="25.71" />
      </symbol>
      <symbol id="point-soubu" data-name="point-soubu" viewBox="0 0 80 80">
        <circle class="cls-3" cx="40" cy="40" r="40" />
        <circle class="cls-2" cx="40" cy="40" r="25.71" />
      </symbol>
      <symbol id="point-oedo" data-name="point-oedo" viewBox="0 0 80 80">
        <circle class="cls-1" cx="40" cy="40" r="40" />
        <circle class="cls-2" cx="40" cy="40" r="25.71" />
      </symbol>
    </defs>
    <MapLayer />
    <template v-for="item in this.mapItems">
      <g
        :id="`tokyo-clickable-group-${item.id}`"
        data-name="clickable_map"
        :key="item.id"
      >
        <circle
          :id="`tokyo-fill-${item.id}`"
          :cx="item.cx"
          :cy="item.cy"
          r="26"
          :aria-checked="isChecked(item.id)"
          class="map-selector-fill"
          :style="{
            fill:
              !shopMapIds || shopMapIds.includes(item.id)
                ? ''
                : '#696969 !important',
          }"
        />
        <circle
          :id="`tokyo-stroke-${item.id}`"
          :cx="item.cx"
          :cy="item.cy"
          r="56"
          stroke-opacity="0.5"
          :aria-checked="isChecked(item.id)"
          @click="selectArea(item.id)"
          class="map-selector-stroke"
        />
      </g>
    </template>
  </svg>
</template>

<script>
import MapLayer from './MapLayer.vue';

export default {
  components: {
    MapLayer,
  },
  props: ['mapAreaId', 'shopMapIds'],
  data: () => ({
    selectedArea: '',
  }),
  computed: {
    mapItems() {
      return [
        {
          id: 1,
          name: this.$t('kinshicho'),
          area_name: this.$t('tokyo_sumida_ku'),
          cx: 947,
          cy: 320,
        },
        {
          id: 2,
          name: this.$t('gotanda_shinagawa'),
          area_name: this.$t('tokyo_shinagawa_ku'),
          cx: 515,
          cy: 627,
        },
        {
          id: 3,
          name: this.$t('roppongi_akasaka'),
          area_name: this.$t('tokyo_minato_ku'),
          cx: 494,
          cy: 476,
        },
        {
          id: 4,
          name: this.$t('shibuya'),
          area_name: this.$t('tokyo_shibuya_ku'),
          cx: 230,
          cy: 475,
        },
        {
          id: 5,
          name: this.$t('shinjuku_kabukicho'),
          area_name: this.$t('tokyo_shinagawa_ku'),
          cx: 189,
          cy: 319,
        },
        {
          id: 6,
          name: this.$t('ikebukuro'),
          area_name: this.$t('tokyo_shinjuku_ku'),
          cx: 277,
          cy: 108,
        },
        {
          id: 7,
          name: this.$t('uguisudani'),
          area_name: this.$t('tokyo_taito_ku'),
          cx: 733,
          cy: 120,
        },
        {
          id: 8,
          name: this.$t('shinbashi_ginza'),
          area_name: this.$t('tokyo_chuo_ku'),
          cx: 759,
          cy: 476,
        },
        {
          id: 9,
          name: this.$t('ebisu_meguro'),
          area_name: this.$t('tokyo_meguro_ku'),
          cx: 351,
          cy: 591,
        },
      ];
    },
  },
  mounted: function() {
    this.selectedArea = this.mapAreaId;
  },
  methods: {
    selectArea(value) {
      if (this.shopMapIds && !this.shopMapIds.includes(value)) return;
      this.selectedArea = value;
      this.$emit('input', value);
      this.$emit('changeMapArea');
    },
    isChecked(value) {
      return this.selectedArea === value;
    },
  },
};
</script>

<style scoped>
.map-selector-fill {
  fill: transparent;
}
.map-selector-fill[aria-checked='true'] {
  fill: #B22C27;
}
.map-selector-stroke {
  fill: transparent;
  stroke: transparent;
  stroke-linejoin: round;
  stroke-width: 8px;
}
.map-selector-stroke:focus {
  outline: none;
}
.map-selector-stroke[aria-checked='true'] {
  stroke: #B22C27;
  stroke-width: 30px;
}
</style>
